import React from 'react';
import './index.less';

const Footer = () => {
  return (
    <iframe
      title={'关于猎聘'}
      width="100%"
      height="335px"
      src="https://wow.liepin.com/t1008985/index.html?mscid=FbAHUwiE"
      frameBorder="0"
    ></iframe>
  );
};

export default Footer;
